"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.autoCompResultSetter = exports.getAutoRes = void 0;
const dcAPI_1 = __importDefault(require("../../api/dcAPI"));
const calculateDistance_1 = __importDefault(require("../calculateDistance"));
const convertMeterStr_1 = __importDefault(require("../convertMeterStr"));
const gpsStorageCtrl_1 = require("../gpsStorageCtrl");
const { lat, lng } = (0, gpsStorageCtrl_1.getGpsCookie)();
let reqCnt = 0;
const getAutoRes = async ({ inputValue, lat, lon, }) => {
    reqCnt += 1;
    // localConsole?.log(reqCnt, "호출획수 ");
    // if (inputValue === "백") {
    //   await delay(1000);
    //   const delayRes = await req.autoCompleteSearch({
    //     text: inputValue,
    //     lat,
    //     lng: lon,
    //   });
    //   return { reqText: inputValue, res: delayRes.data };
    // }
    const res = await dcAPI_1.default.autoCompleteSearch({ text: inputValue, lat, lng: lon });
    const roadAddrRes = res.data?.rest?.map((item) => {
        if (item && item.road_addr) {
            return {
                ...item,
                addr: item.road_addr,
            };
        }
        return item;
    });
    return {
        reqText: inputValue,
        restRes: roadAddrRes,
        keywordRes: res.data?.keyword
    };
};
exports.getAutoRes = getAutoRes;
const autoCompResultSetter = ({ key, restValue, keywordValue, reqText, setAutoValue, }) => {
    const calcedRestRes = restValue &&
        restValue.map((elem) => {
            if (elem && elem.gps && elem.gps.lat && elem.gps.lon) {
                return {
                    ...elem,
                    distance: (0, convertMeterStr_1.default)((0, calculateDistance_1.default)(Number(elem.gps.lat), Number(elem.gps.lon), Number(lat), Number(lng))),
                };
            }
            return elem;
        });
    setAutoValue({
        rest: calcedRestRes,
        keyword: keywordValue
    });
    return reqText;
};
exports.autoCompResultSetter = autoCompResultSetter;
